// extracted by mini-css-extract-plugin
export var contentContainer = "PartnersSection-module--contentContainer--991Kl";
export var lamp = "PartnersSection-module--lamp--y-V-9";
export var lampAndLightContainer = "PartnersSection-module--lampAndLightContainer--6iJBf";
export var lampContainer = "PartnersSection-module--lampContainer--C0aEv";
export var light = "PartnersSection-module--light--5lAD6";
export var mainText = "PartnersSection-module--mainText--8dISY";
export var partnersContainer = "PartnersSection-module--partnersContainer--pNhrH";
export var partnersLogosContainer = "PartnersSection-module--partnersLogosContainer--+ULVq";